/* eslint-disable */
<template>
  <div class="live-session__analytics px-3" ref='analytics'>
    <v-progress-linear
      v-if="!chartDataLoaded && visible"
      indeterminate
      height="2"></v-progress-linear>
    <HorizontalBarChart
      v-if="chartDataLoaded && visible"
      :key="`live-session-barchart-${interactionId}`"
      :chart-data="chartData"
      :options="options"
      :styles="barChartStyle"
      :aria-label="chartAriaLabel"
      role="alert"
    ></HorizontalBarChart>
  </div>
</template>
<script>
/*global _*/
import HorizontalBarChart from './HorizontalBarChart';
import { mapState, mapGetters, mapActions, mapMutations} from 'vuex';
export default {
  name: 'LiveSessionAnalytics',
  components: {
    HorizontalBarChart,
  },
  props: [
    'darkMode',
    'interactionId', // setup prop definitions
    'sectionId', // setup prop definitions
    'visible',
  ],
  data() {
    return {
      alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p'],
      chartAriaLabel: '',
      chartDataLoaded: false,
      chartData: { },
      chartHeight: '300px',
      options: {
        title: {
          display: false, 
          position: 'top',
          text: `Session Answer Summary`,
        },
        tooltips: {enabled: false},
        hover: {mode: null},
        scales: {
          xAxes: [
            {
              display: false,
              legend: {
                display: false,
              },
              ticks: {
                min: 0,
              }
            }
          ],
          yAxes: [
            {
              gridLines: { 
                display: false,
              },
              ticks: {
                beginAtZero: true,
                stepSize: 1,
                fontColor: this.darkMode ? 'white' : '#000',
                fontSize: 15,
              },
            }
          ]
        },
        layout: {
          padding: {
            // This padding is needed to allow for dataLabels to not be cutoff
            right: 48,
          }
        },
        plugins:{
          datalabels: {
            anchor: 'end',
            align: 'right',
            formatter: function(value, context) {
              let totalResponses = 0;
              for (const response of context.dataset.data) {
                totalResponses += response;
              }
              return totalResponses > 0 ? `${((value/totalResponses) * 100).toFixed()}%` : '0%';
            },
            font: {
              size: 15,
            },
            color: this.darkMode ? 'white' : '#000',
          }
        },
      },
      totalDataResponses: 0,
    }; // end return 
  }, // end data
  methods: {
    ...mapActions('interactions', [
      'getInteractionAnalytics',
    ]),
    createChartAriaLabel() {
      for (const response of _.get(this.chartData, 'datasets[0].data')) {
        this.totalDataResponses += response;
      }
      for (const [index, data] of _.get(this.chartData, 'datasets[0].data').entries()) {
        this.chartAriaLabel += `Choice ${this.alphabet[index]} - ${ Math.round((data / this.totalDataResponses) * 100) } percent. `;
      }
    },
  },
  computed: {
    barChartStyle() {
      return {
        position: 'relative',
        width: '100%',
        height: this.chartHeight,
        'margin-bottom': '40px',
      };
    },
  },
  async mounted() {
    setTimeout(async () => {
      // We wait 0 - 2000ms to make the analytics call - we cache the results so longer calls should result in more hitting the cache
      this.chartData = await this.getInteractionAnalytics({
        interactionId: this.interactionId,
        sectionId: this.sectionId,
      });
      if (!this.chartData) {
        this.chartData = await this.getInteractionAnalytics({
          interactionId: this.interactionId,
          sectionId: this.sectionId,
          cache: false,
        });
      }
      if (_.get(this.chartData, 'datasets')) {
        if (this.darkMode) {
          // set font colors to white for dark mode interactions
          this.options.title.fontColor = '#FFF';
        }
        if (_.get(this.chartData, 'datasets[0].data', []).length) {
          this.chartHeight = `${(_.get(this.chartData, 'datasets[0].data', []).length * 50)}px`;
        }
        this.chartData.datasets[0] = { ...this.chartData.datasets[0], ...{'barPercentage': 0.2, 'categoryPercentage': 1}};
        this.createChartAriaLabel();
        this.chartDataLoaded = true;
        this.$refs.analytics.scrollIntoView(true);
      }
    }, Math.floor(Math.random() * 2001));
    
  },
}

</script>
